import React from 'react';
import {
  RemoveTagFunction,
  MarkAsDuplicateFunction,
  MoveToFunction,
  SelectionChangeFunction,
  Study,
  UndoDuplicateFunction,
} from '../StudyList';
import MoveToCategory from '../components/MoveToCategory';
import { NotesButton } from './components/NotesModal/NotesButton';
import { HistoryButton } from './HistoryButton';
import { DuplicateButton } from './DuplicateButton';
import { AddTagButton } from './components/AddTagButton';
import { StudyReference } from './StudyReference';
import { StudyListItem } from './StudyListItem';
import { StudyTags } from './StudyTags';
import { Inline, Stack } from 'components/layout';

type IrrelevantStudyListItemProps = {
  study: Study;
  reviewId: string;
  showAbstracts: boolean;
  justUndone: boolean;
  isSelected?: boolean;
  onRemoveTag: RemoveTagFunction;
  onSelectionChange?: SelectionChangeFunction;
  onMoveToScreening: MoveToFunction;
  onMarkAsDuplicate: MarkAsDuplicateFunction;
  onUndoDuplicate: UndoDuplicateFunction;
};

const IrrelevantStudyListItem = ({
  study,
  reviewId,
  showAbstracts,
  justUndone,
  isSelected = false,
  onRemoveTag,
  onSelectionChange = () => null,
  onMoveToScreening,
  onMarkAsDuplicate,
  onUndoDuplicate,
}: IrrelevantStudyListItemProps) => {
  return (
    <StudyListItem
      uniqueIndex={study.unique_index}
      title={study.title}
      isSelected={isSelected}
      handleSelectionChange={(isChecked) =>
        onSelectionChange(study.id, isChecked)
      }
      justUndone={justUndone}
    >
      <Stack spacing={2}>
        <StudyReference
          reviewId={reviewId}
          study={study}
          showAbstracts={showAbstracts}
        />
        <Inline spacing={3} rowSpacing={2} alignX="left">
          <MoveToCategory
            category="screen"
            uniqueIndex={study.unique_index}
            onMoveToCategory={() => onMoveToScreening(study.id)}
          />
          <NotesButton
            initialNotesCount={study.notes.length}
            reviewStudyId={study.id}
            noteCategory="Irrelevant"
            title={study.title}
          />
          <HistoryButton study={study} category="Irrelevant" />
          <DuplicateButton
            uniqueIndex={study.unique_index}
            reviewId={reviewId}
            studyId={study.id}
            onMarkAsDuplicate={onMarkAsDuplicate}
            onUndoDuplicate={onUndoDuplicate}
          />
          <AddTagButton
            studyId={study.id}
            onSelectionChange={onSelectionChange}
          />
        </Inline>
        <StudyTags
          tags={study.tags}
          removeTag={(tag) => onRemoveTag(study.id, tag)}
        />
      </Stack>
    </StudyListItem>
  );
};

export default IrrelevantStudyListItem;
